import React from 'react';
import Container from './Container';

function PageHeader({ heading, description, children }) {
  return (
    <Container>
      <div className='max-w-2xl mx-auto mt-5 mb-10'>
        <div className='space-y-4 text-center'>
          <h1 className='text-3xl font-extrabold tracking-tight text-neutral-200 sm:text-5xl md:text-6xl'>
            <span className='block xl:inline'>{heading}</span>
          </h1>

          <div className='mx-auto space-y-4'>
            <p className='text-base text-neutral-500 md:text-xl'>{description}</p>
            {children}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default PageHeader;
